import { render, staticRenderFns } from "./Dropzone.vue?vue&type=template&id=462d8495&scoped=true&"
import script from "./Dropzone.vue?vue&type=script&lang=js&"
export * from "./Dropzone.vue?vue&type=script&lang=js&"
import style0 from "./Dropzone.vue?vue&type=style&index=0&id=462d8495&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462d8495",
  null
  
)

export default component.exports